export enum DefaultPage {
  waitlist = 1,
  reservation = 2,
  floorPlan = 3,
}
